export const SUGGEST_PRODUCTS = "SUGGEST_PRODUCTS";
export const SHOW_LOADING = "SHOW_LOADING";
export const API_ERROR = "API_ERROR";
export const GET_PRODUCTS = "GET_PRODUCTS";
export const SHOW_PRODUCT_CATEGORIES = "SHOW_PRODUCT_CATEGORIES";
export const GET_PRODUCT_DETAILS = "GET_PRODUCT_DETAILS";
export const GET_PRODUCTS_ERROR = "GET_PRODUCTS_ERROR";
export const GET_PRODUCT_CATEGORIES = "GET_PRODUCT_CATEGORIES";
export const ADD_ADDRESS = "ADD_ADDRESS";
export const REMOVE_ADDRESS = "REMOVE_ADDRESS";
export const SET_DEFAULT_ADDRESS = "SET_DEFAULT_ADDRESS";
export const ADD_TO_CART = "ADD_TO_CART";
export const REMOVE_FROM_CART = "REMOVE_FROM_CART";
export const ADD_TO_WISHLIST = "ADD_TO_WISHLIST";
export const REMOVE_FROM_WISHLIST = "REMOVE_FROM_WISHLIST";
export const START_PURCHASE_TRANSACTION = "START_PURCHASE_TRANSACTION";
export const PURCHASE_TRANSACTION_SUCCESS = "PURCHASE_TRANSACTION_SUCCESS";
export const PURCHASE_TRANSACTION_FAILED = "PURCHASE_TRANSACTION_SUCCESS";
